// Mock data for WebDream landing page

export const offers = [
  {
    id: 'vitrine',
    name: 'Site Vitrine',
    price: 500,
    deposit: '30-50%',
    tagline: 'Idéal pour présenter votre commerce',
    description: "Une présence en ligne élégante pour attirer de nouveaux clients et mettre en avant votre activité.",
    features: [
      'Design sur-mesure',
      'Jusqu\u2019à 5 pages',
      'Formulaire de contact',
      'Optimisé mobile & SEO',
      'Mise en ligne incluse',
      'Formation à la gestion'
    ]
  },
  {
    id: 'siteweb',
    name: 'Site Web Complet',
    price: 1000,
    deposit: '30-50%',
    tagline: 'Pour les entreprises ambitieuses',
    description: 'Un site professionnel avec fonctionnalités avancées : catalogue, réservations, ou boutique en ligne.',
    features: [
      'Design premium personnalisé',
      'Pages illimitées',
      'Catalogue produits / services',
      'Réservation ou e-commerce',
      'SEO avancé & performance',
      'Suivi et support prioritaire'
    ]
  }
];

export const process = [
  {
    step: '01',
    title: 'Discussion',
    text: "On échange sur votre projet, votre commerce et vos besoins. C\u2019est gratuit et sans engagement."
  },
  {
    step: '02',
    title: 'Devis & Acompte',
    text: "Vous validez le devis et versez un acompte de 30 à 50% pour lancer le projet."
  },
  {
    step: '03',
    title: 'Création',
    text: 'Je conçois votre site, avec des points d\u2019étape pour ajuster le design ensemble.'
  },
  {
    step: '04',
    title: 'Livraison',
    text: 'Mise en ligne, formation, et solde à réception. Votre commerce est prêt à briller sur le web.'
  }
];

export const contactInfo = {
  name: 'Nolan Longchamps',
  email: 'nolanlq@icloud.com',
  phone: '06 69 47 75 36'
};
